// src/RoutesConfig.tsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';

// Dashboard & Core
import Dashboard from '../pages/Dashboard';
import LoginPage from '../pages/LoginPage';

// Products
import ProductsListPage from '../pages/ProductListPage';
import AddProductPage from '../pages/AddProductPage';
import EditProductPage from '../pages/EditProductPage';
import CategoriesPage from '../pages/CategoriesPage';

// Users & Locations
import UsersPage from '../pages/UsersPage';
import LocationsPage from '../pages/LocationsPage';
import WholesaleRequestsPage from '../pages/WholesaleRequestsPage';
import WholesaleTiersPage from '../pages/WholesaleTiersPage';

// Sales & Orders
import SellPage from '../pages/SellPage';
import OrdersPage from '../pages/OrdersPage';
import AdminCreateOrderPage from "../pages/AdminCreateOrderPage";

// Settings
import SettingsPage from '../pages/SettingsPage';
import LoyaltySettings from '../pages/LoyaltySettings';
import StoreCreditSettings from '../pages/StoreCreditSettings';
import ShippingRatesPage from '../pages/ShippingRatesPage';

// 🆕 Delivery Settings Pages
import DeliverySettings from '../pages/DeliverySettings';
import DeliveryZones from '../pages/DeliveryZones';

// Inventory / Stock / Suppliers
import StockReceivePage from "../pages/StockReceivePage";
import StockReceiptListPage from '../pages/StockReceiptListPage';
import StockReceiptDetailPage from '../pages/StockReceiptDetailPage';
import ReorderListPage from '../pages/ReorderListPage';
import SupplierManagementPage from '../pages/SupplierManagementPage';

import FulfillmentPage from "../pages/FulfillmentPage";

import DriversPage from '../pages/DriversPage';
import HeroSettingsPage from "../pages/HeroSettingsPage";
import CouponsPage from '../pages/CouponsPage';
import PromotionsPage from '../pages/PromotionsPage';
import OrderEditPage from '../pages/OrderEditPage';
import MediaLibraryPage from '../pages/admin/MediaLibraryPage';
import PaymentSettingsPage from '../pages/PaymentSettingsPage';

const RoutesConfig: React.FC = () => {
  const user = localStorage.getItem('authToken'); // Simplified auth check

  return (
    <Routes>
      {/* Auth */}
      <Route
        path="/login"
        element={user ? <Navigate to="/dashboard" replace /> : <LoginPage />}
      />

      {/* Dashboard */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />

      {/* Products */}
      <Route
        path="/products"
        element={
          <ProtectedRoute>
            <ProductsListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/add"
        element={
          <ProtectedRoute>
            <AddProductPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/products/edit/:id"
        element={
          <ProtectedRoute>
            <EditProductPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/categories"
        element={
          <ProtectedRoute>
            <CategoriesPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/media"
        element={
          <ProtectedRoute>
            <MediaLibraryPage />
          </ProtectedRoute>
        }
      />

      {/* Users & Locations */}
      <Route
        path="/users"
        element={
          <ProtectedRoute>
            <UsersPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/locations"
        element={
          <ProtectedRoute>
            <LocationsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wholesale-requests"
        element={
          <ProtectedRoute>
            <WholesaleRequestsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/wholesale-tiers"
        element={
          <ProtectedRoute>
            <WholesaleTiersPage />
          </ProtectedRoute>
        }
      />

      {/* Orders & POS */}
      <Route
        path="/orders"
        element={
          <ProtectedRoute>
            <OrdersPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/orders/create"
        element={
          <ProtectedRoute>
            <AdminCreateOrderPage />
          </ProtectedRoute>
        }
      />


      <Route
        path="/orders/:orderId/edit"
        element={
          <ProtectedRoute>
            <OrderEditPage />
          </ProtectedRoute>
        }
      />

      {/* 🆕 Fulfillment */}
      <Route
        path="/fulfillments/:id"
        element={
          <ProtectedRoute>
            <FulfillmentPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/sell"
        element={
          <ProtectedRoute>
            <SellPage />
          </ProtectedRoute>
        }
      />

      {/* Settings */}
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <SettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/hero"
        element={
          <ProtectedRoute>
            <HeroSettingsPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/loyalty"
        element={
          <ProtectedRoute>
            <LoyaltySettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/store-credit"
        element={
          <ProtectedRoute>
            <StoreCreditSettings />
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings/shipping"
        element={
          <ProtectedRoute>
            <ShippingRatesPage />
          </ProtectedRoute>
        }
      />

      {/* 🆕 Delivery Settings */}
      <Route
        path="/settings/delivery-settings"
        element={
          <ProtectedRoute>
            <DeliverySettings />
          </ProtectedRoute>
        }
      />

      {/* 🆕 Delivery Zones */}
      <Route
        path="/settings/delivery-zones"
        element={
          <ProtectedRoute>
            <DeliveryZones />
          </ProtectedRoute>
        }
      />

      <Route
        path="/settings/coupons"
        element={
          <ProtectedRoute>
            <CouponsPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/settings/promotions"
        element={
          <ProtectedRoute>
            <PromotionsPage />
          </ProtectedRoute>
        }
      />
      <Route
  path="/settings/payments"
  element={
    <ProtectedRoute>
      <PaymentSettingsPage />
    </ProtectedRoute>
  }
/>

      {/* Inventory / Stock */}
      <Route
        path="/stock-receive"
        element={
          <ProtectedRoute>
            <StockReceivePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock-receipts"
        element={
          <ProtectedRoute>
            <StockReceiptListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/stock-receipts/:id"
        element={
          <ProtectedRoute>
            <StockReceiptDetailPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/reorder-list"
        element={
          <ProtectedRoute>
            <ReorderListPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/supplier-list"
        element={
          <ProtectedRoute>
            <SupplierManagementPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/drivers"
        element={
          <ProtectedRoute>
            <DriversPage />
          </ProtectedRoute>
        }
      />

      {/* Default redirect */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default RoutesConfig;